import {
  KeyboardArrowLeft,
  Menu,
} from "@mui/icons-material";
import {
  Box,
  Typography,
} from "@mui/material";
import MMenuDrawer from "components/MMenuDrawer";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function MHeaderSection() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        py={1}
        borderBottom={1}
        borderColor="divider"
      >
        <Box
          display="flex"
          color="#af9b65"
          flex={1}
          alignItems="center"
          onClick={() => {
            navigate("/stores");
          }}
        >
          <KeyboardArrowLeft />
          <Typography fontWeight="bold">神谷町</Typography>
        </Box>
        <Box
          height="40px"
          width="110px"
          component="img"
          src="/images/appIcon.png"
        />
        <Box
          display="flex"
          flex={1}
          justifyContent="end"
          color="#af9b65"
          px={2}
          alignItems="center"
        >
          <Box onClick={() => setOpen(true)}>
            <Menu />
          </Box>
        </Box>
      </Box>
      <MMenuDrawer isOpen={open} handleClose={handleClose} />
    </>
  );
}
